module.exports = __webpack_public_path__ + "img/table_lamp.9eb0225f.png";